import { uuid } from "@tencent/midas-util"
/**
 * 获得 luckDraw uuid
 * 形如： 20170912-1233abc
 */
export default function () {
  return `${new Date()
    .toISOString()
    .substr(0, 10)
    .replace(/-/g, "")}-${uuid(5).toLowerCase()}`
}
